module.exports = {
      id: "share-link-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#share-link",
      toString: function () {
        return this.url;
      }
    }